<div [@slide]="state"
     (@slide.done)="animationDone($event)">

    <ng-container *ngIf="magazine">

        <kal-icon (click)="close()">close</kal-icon>

        <kal-menu #shareMenu>
            <kal-option (selectionChange)="share('email')">
                Par e-Mail
            </kal-option>
            <kal-option (selectionChange)="share('article')">
                Partager l'article sur le site Internet de votre CSE
            </kal-option>
        </kal-menu>

        <kal-icon [kalMenuTriggerFor]="shareMenu">share</kal-icon>

        <!--Désactivation de cette fonctionnalité en attendant qu'elle soit à nouveau développée-->
        <!--<kal-icon [class.outlined]="magazine.CanLike"
                  (click)="likeMagazine()">
            thumb_up
        </kal-icon>

        <span class="countLike">{{ magazine.NombreLikes }}</span>-->

        <section>

            <figure
                *ngIf="picture as src"
                [style.background-image]="'url(' + src + ')'">
            </figure>

            <article>

                <h4 [innerHtml]="magazine.Titre | sanitize:'html'"></h4>

                <img *ngIf="!isLarge && picture as src" [src]="src"/>

                <div [innerHtml]="magazine.Contenu | sanitize:'html'"></div>

            </article>

        </section>

    </ng-container>

</div>
